import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-4 flex flex-col gap-y-4" }
const _hoisted_2 = { class: "flex items-center w-full" }
const _hoisted_3 = {
  key: 1,
  class: "text-black-lp-100"
}
const _hoisted_4 = {
  key: 3,
  class: "text-sm text-gray-lp-2400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Title = _resolveComponent("Title")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { rounded: "2xl" }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              height: "1.25rem",
              width: "20%"
            }))
          : (_openBlock(), _createBlock(_component_Title, {
              key: 1,
              label: "Status Pesanan",
              fontColor: "text-gray-lp-2300",
              fontSize: 18,
              bold: "medium"
            })),
        _createVNode("div", {
          class: `grid grid-cols-${_ctx.steps.length}`
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
            return (_openBlock(), _createBlock("div", {
              key: index,
              class: "flex flex-col items-center text-center flex-1"
            }, [
              _createVNode("div", _hoisted_2, [
                (_ctx.loading && index)
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 0,
                      height: "0.125rem",
                      width: "45%",
                      class: "mr-2"
                    }))
                  : (_openBlock(), _createBlock("div", {
                      key: 1,
                      class: ["h-1px w-1/2 mr-2", _ctx.getLineClass(index, 'left')]
                    }, null, 2)),
                (_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 2,
                      height: "1.5rem",
                      width: "1.5rem"
                    }))
                  : (_openBlock(), _createBlock("div", {
                      key: 3,
                      class: ["flex h-5 w-5 items-center justify-center rounded-full bg-white flex-shrink-0 border", 
                _ctx.isCancelled(step)
                  ? 'border-red-lp-100 text-red-lp-100'
                  : index <= _ctx.lastActiveIndex
                  ? 'border-green-lp-100 text-green-lp-100'
                  : 'border-gray-lp-600 text-gray-lp-600'
              ],
                      style: {"border-width":"1.5px"}
                    }, [
                      _createVNode(_component_Icons, {
                        name: _ctx.isCancelled(step) ? 'close' : 'check',
                        class: "w-3"
                      }, null, 8, ["name"])
                    ], 2)),
                (_ctx.loading && index !== _ctx.steps.length - 1)
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 4,
                      height: "0.125rem",
                      width: "45%",
                      class: "ml-2"
                    }))
                  : (!_ctx.loading)
                    ? (_openBlock(), _createBlock("div", {
                        key: 5,
                        class: ["h-1px w-1/2 ml-2", _ctx.getLineClass(index, 'right')]
                      }, null, 2))
                    : _createCommentVNode("", true)
              ]),
              _createVNode("div", {
                class: ["mt-3 px-2 text-sm font-medium w-full flex flex-col justify-center items-center", { 'gap-y-1': _ctx.loading }]
              }, [
                (_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 0,
                      height: "1rem",
                      width: "70%"
                    }))
                  : (_openBlock(), _createBlock("p", _hoisted_3, _toDisplayString(step.label), 1)),
                (_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 2,
                      height: "1rem",
                      width: "90%"
                    }))
                  : (step.createdAt)
                    ? (_openBlock(), _createBlock("p", _hoisted_4, _toDisplayString(_ctx.formatDate(step.createdAt)), 1))
                    : _createCommentVNode("", true)
              ], 2)
            ]))
          }), 128))
        ], 2)
      ])
    ]),
    _: 1
  }))
}